import React from "react";
import styles from "./BackgroundHTML.module.css";

function BackgroundHTML1() {
  return (
    <div className={styles.backgroundHTML1}>
      {/* <pre>
        <span className={styles.lessthan}>&lt;</span><span className={styles.tag}>p</span><span className={styles.greaterthan}>&gt;</span>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.lessthan}>&lt;</span><span className={styles.tag}>div</span> <span className={styles.class}>className=</span><span className={styles.classValue}>"headRight"</span><span className={styles.greaterthan}>&gt;</span>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.lessthan}>&lt;</span><span className={styles.tag}>button</span> <span className={styles.class}>className=</span><span className={styles.classValue}>"logout"</span><span className={styles.greaterthan}>&gt;</span>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;props.name ? "Logout" : "Login"&#125;<br/>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.lessthan}>&lt;</span><span className={styles.tag}>/button</span><span className={styles.greaterthan}>&gt;</span>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.lessthan}>&lt;</span><span className={styles.tag}>div</span> <span className={styles.class}>className=</span><span className={styles.classValue}>"newChat"</span> onClick="setFindMode"<span className={styles.greaterthan}>&gt;</span>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.lessthan}>&lt;</span><span className={styles.component}>PersonAddRoundedIcon</span> <span className={styles.class}>className=</span><span className={styles.classValue}>"icon"</span> <span className={styles.class}>style=</span>&#123;fontSize:<span className={styles.classValue}>"35px"</span>&#125;<span className={styles.greaterthan}>&gt;</span>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.lessthan}>&lt;</span><span className={styles.tag}>/div</span><span className={styles.greaterthan}>&gt;</span>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.lessthan}>&lt;</span><span className={styles.tag}>div</span> <span className={styles.class}>className=</span><span className={styles.classValue}>"settings"</span><span className={styles.greaterthan}>&gt;</span>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.lessthan}>&lt;</span><span className={styles.component}>SettingsRoundedIcon</span> <span className={styles.class}>className=</span><span className={styles.classValue}>"icon"</span> <span className={styles.class}>style=</span>&#123;fontSize: <span className={styles.classValue}>"35px"</span>&#125;<span className={styles.greaterthan}>&gt;</span>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.lessthan}>&lt;</span><span className={styles.tag}>/div</span><span className={styles.greaterthan}>&gt;</span>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.lessthan}>&lt;</span><span className={styles.tag}>/div</span><span className={styles.greaterthan}>&gt;</span>
        <br />
        <span className={styles.lessthan}>&lt;</span><span className={styles.tag}>/p</span><span className={styles.greaterthan}>&gt;</span>
        <br />
      </pre> */}
      <pre>
        <span className={styles.lessthan}>&lt;</span>
        <span className={styles.tag}>p</span>
        <span className={styles.greaterthan}>&gt;</span>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.lessthan}>&lt;</span>
        <span className={styles.tag}>div</span>{" "}
        <span className={styles.class}>className=</span>
        <span className={styles.classValue}>"headRight"</span>
        <span className={styles.greaterthan}>&gt;</span>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span className={styles.lessthan}>&lt;</span>
        <span className={styles.tag}>div</span>{" "}
        <span className={styles.class}>className=</span>
        <span className={styles.classValue}>"settings"</span>
        <span className={styles.greaterthan}>&gt;</span>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span className={styles.lessthan}>&lt;</span>
        <span className={styles.component}>SettingsRoundedIcon</span>{" "}
        <span className={styles.class}>className=</span>
        <span className={styles.classValue}>"icon"</span>{" "}
        <span className={styles.class}>style=</span>&#123;fontSize:{" "}
        <span className={styles.classValue}>"35px"</span>&#125;
        <span className={styles.greaterthan}>&gt;</span>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span className={styles.lessthan}>&lt;</span>
        <span className={styles.tag}>/div</span>
        <span className={styles.greaterthan}>&gt;</span>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.lessthan}>&lt;</span>
        <span className={styles.tag}>/div</span>
        <span className={styles.greaterthan}>&gt;</span>
        <br />
        <span className={styles.lessthan}>&lt;</span>
        <span className={styles.tag}>/p</span>
        <span className={styles.greaterthan}>&gt;</span>
        <br />
      </pre>
    </div>
  );
}

export default BackgroundHTML1;
